import { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useBreakpoints from '../../../../../../common/hooks/useBreakpoints';
import useToggleClass from '../../../../../../common/hooks/useToggleClass';
import { CustomerInfoContext } from '../../../../contexts/CustomerInfoContext';
import { BenefitType } from '../../../../enums';
import { resources } from '../../../../resources/resources';
import BenefitNav from './components/BenefitNavItem';

interface ICategoriesNavProps {
  onCloseMenu: () => void;
}

export default function CategoriesNavArea(props: ICategoriesNavProps) {
  const categoriesNavRef = useRef(null);

  const { t: translate } = useTranslation();
  const { isTablet } = useBreakpoints();
  const { addClass, removeClass } = useToggleClass();
  const { customerInfo } = useContext(CustomerInfoContext);
  const contests = customerInfo.contests || [];
  const [showDiscover] = useState(false);

  useEffect(() => {
    if (!isTablet) {
      removeClass('categories-tablet', categoriesNavRef);
      addClass('categories-desktop', categoriesNavRef);
    } else {
      removeClass('categories-desktop', categoriesNavRef);
      addClass('categories-tablet', categoriesNavRef);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTablet]);

  return (
    <>
      <nav className="categories-nav" ref={categoriesNavRef}>
        <ul>
          {customerInfo.canAccessFlexibleBenefits && (
            <BenefitNav
              benefitsType={BenefitType.Flexible}
              isTablet={isTablet}
              closeMenu={props.onCloseMenu}
            />
          )}
          {customerInfo.canAccessBenefitClub && (
            <BenefitNav
              noColumns={4}
              benefitsType={BenefitType.Club}
              isTablet={isTablet}
              closeMenu={props.onCloseMenu}
            />
          )}
          {customerInfo.canAccessDiscountVouchers && (
            <BenefitNav
              benefitsType={BenefitType.DiscountVouchers}
              isTablet={isTablet}
              closeMenu={props.onCloseMenu}
            />
          )}
          {customerInfo.canAccessCashback && (
            <BenefitNav
              benefitsType={BenefitType.Cashback}
              isTablet={isTablet}
              closeMenu={props.onCloseMenu}
            />
          )}
          {customerInfo.canAccessMyCards && (
            <li>
              <Link
                to="/my-account/cards"
                onClick={() => {
                  props.onCloseMenu();
                }}
              >
                <span>{translate(resources.menu.cards)}</span>
              </Link>
            </li>
          )}
          {showDiscover && (
            <li>
              <Link
                to="/discover"
                onClick={() => {
                  props.onCloseMenu();
                }}
              >
                <span>{translate(resources.discover.header)}</span>
              </Link>
            </li>
          )}
          {!!contests.length && (
            <li>
              <Link
                to={`/contests`}
                onClick={() => {
                  props.onCloseMenu();
                }}
              >
                <span>{translate(resources.contests.contests)}</span>
              </Link>
            </li>
          )}
        </ul>
      </nav>
    </>
  );
}
